import React from "react";
import Modal from "./Modal";

const ConfirmModal = ({
  show,
  message,
  onConfirm,
  onCancel,
  title,
  confirmLabel = "Delete",
  confirmDisabled = false,
}) => {
  if (!show) return null;

  return (
    <Modal isOpen={show} onClose={onCancel} contentClassName="max-w-md">
      <div className="p-4 bg-white rounded-lg shadow-md">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="mb-4 text-sm text-gray-600 pb-3">{message}</p>

        <div className="flex justify-end gap-4">
          <button
            type="button"
            onClick={onCancel}
            autoFocus
            className="px-4 py-2 rounded border"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirmDisabled}
            className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
